import { render, staticRenderFns } from "./ApprovalDeleted.vue?vue&type=template&id=a25dcb7a&"
import script from "./ApprovalDeleted.vue?vue&type=script&lang=ts&"
export * from "./ApprovalDeleted.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports